module.exports = __webpack_public_path__ + "static/img/bank4-1.b05e59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/bank4-1.png
// module id = xMD3
// module chunks = 1